import dynamic from 'next/dynamic'
import { useEffect } from 'react'
import { ContactUsModal } from 'src/components/account/contact-us'
import { UserListModal } from 'src/components/user-list-modal'
import { UserListsModal } from 'src/components/user-lists-modal'
import { useSetUpUserLists } from 'src/hooks/use-setup-userlists'
import { UserBack } from 'src/components/user-back'
import { Intercom } from 'src/components/intercom'
import { MapOverlayModal } from 'src/layout/modals/map-overlay'

export const UserListLoader = () => {
  const { setUpUserLists } = useSetUpUserLists()

  useEffect(() => {
    void setUpUserLists()
  }, [])

  return null
}

const AdminModals = dynamic(() => import('src/layout/admin-modals'), {
  ssr: false,
})

export const Modals = () => {
  return (
    <>
      <AdminModals />
      <ContactUsModal />
      <UserListsModal />
      <UserListModal />
      <UserListLoader />
      <UserBack />
      <Intercom />
      <MapOverlayModal />
    </>
  )
}
